import { render, staticRenderFns } from "./SpecialtiesManagement.html?vue&type=template&id=0d76d0e6&scoped=true&external"
import script from "./SpecialtiesManagement.vue?vue&type=script&lang=js"
export * from "./SpecialtiesManagement.vue?vue&type=script&lang=js"
import style0 from "./SpecialtiesManagement.scss?vue&type=style&index=0&id=0d76d0e6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76d0e6",
  null
  
)

export default component.exports